<template>
    <div>
        <h4 class="mb-6" v-if="templateList === 0">Input Templates</h4>
        <h4 class="mb-6" v-if="templateList === 1">Work Templates</h4>
        <h4 class="mb-6" v-if="templateList === 2">Output Templates</h4>
        <h4 class="mb-6" v-if="templateList === 3">Shaka Templates</h4>

        <vs-button v-if="!addTemplateCard" color="success" icon-pack="feather" icon="icon-plus-circle" class="mb-3" @click="addTemplateCard = true">Add</vs-button>

        <vx-card v-show="addTemplateCard" title="Add template" class="mb-6" id="addTemplateDiv">

            <div class="vx-row">
                <div class="vx-col lg:w-2/3 w-full">
                    <p class="mt-6">Name</p>
                    <vs-input v-model="addObject['name']" class="w-full"></vs-input>
                    <p class="mt-6">Template</p>
                    <vs-input v-model="addObject['template']" class="w-full"></vs-input>
                    <h5 class="mt-6">Parameters</h5>
                    <div :key="index" class="vx-row mb-3" v-for="(param, index) in templateParams">
                        <div class="vx-col w-1/3">
                            <vs-input :disabled="true" v-model="templateParams[index]" class="w-full mt-6"></vs-input>
                        </div>
                        <div class="vx-col w-1/3">
                            <p>Name</p>
                            <vs-input v-model="paramNames[param]" class="w-full"></vs-input>
                        </div>
                        <div class="vx-col w-1/3">
                            <p>Default value</p>
                            <vs-input v-model="paramDefaults[param]" class="w-full"></vs-input>
                        </div>
                    </div>
                </div>
                <div class="vx-col lg:w-1/3 w-full">

                    <h4>Default parameters</h4>
                    <vs-divider/>

                    <h6 class="mt-3">source_url</h6>
                    <p>Channel source URL</p>

                    <h6 class="mt-3">channel_name</h6>
                    <p>Full channel name</p>

                    <h6 class="mt-3">channel_name_serialized</h6>
                    <p>Serialized channel name (lowercase alpha-numeric and _)</p>

                    <h6 class="mt-3">channel_id</h6>
                    <p>Internal channel ID</p>

                    <h6 class="mt-3">worker_channel_name</h6>
                    <p>Full worker channel name</p>

                    <h6 class="mt-3">worker_channel_name_serialized</h6>
                    <p>Serialized worker channel name (lowercase alpha-numeric and _)</p>

                    <h6 class="mt-3">worker_channel_id</h6>
                    <p>Internal worker channel ID</p>

                    <h6 class="mt-3">local_http_folder</h6>
                    <p>Local folder with HLS files</p>

                    <h6 class="mt-3">local_http_m3u8</h6>
                    <p>Local path to m3u8 file</p>

                    <h6 class="mt-3">worker_name</h6>
                    <p>Name of worker running channel</p>

                    <h6 class="mt-3">worker_id</h6>
                    <p>ID of worker running channel</p>

                    <h6 class="mt-3">remote_http_folder</h6>
                    <p>Remote path to folder with HLS files</p>

                    <h6 class="mt-3">remote_http_m3u8</h6>
                    <p>Remote path to m3u8 file</p>

                    <h6 class="mt-3">remote_worker_ip</h6>
                    <p>IP of remote worker/cluster (when worker/cluster is picked as upstream)</p>

                    <h6 class="mt-3">drm_signer</h6>
                    <p>DRM Signer</p>

                    <h6 class="mt-3">drm_key_server</h6>
                    <p>DRM Key server</p>

                    <h6 class="mt-3">drm_content_id</h6>
                    <p>DRM Content id (in hex)</p>

                    <h6 class="mt-3">drm_signing_key</h6>
                    <p>DRM Signing key</p>

                    <h6 class="mt-3">drm_signing_iv</h6>
                    <p>DRM Signing IV</p>
                </div>
            </div>

            <vs-divider/>
            <vs-button style="float: left" color="success" icon-pack="feather" icon="icon-plus-circle" class="mb-3 mr-3" @click="addTemplate" :disabled="!templateInputValid">Add</vs-button>
            <vs-button style="float: left" color="danger" icon-pack="feather" icon="icon-x-circle" class="mb-3" @click="addTemplateCard = false">Cancel</vs-button>
            <div style="clear: left"></div>
        </vx-card>

        <vx-card>
            <vs-table id="table" ref="table" @selected="openTemplate" pagination :max-items="itemsPerPage" search :data="tableData">

                <div slot="header" class="flex flex-wrap-reverse items-center flex-grow justify-between">

                    <vs-dropdown vs-trigger-click class="cursor-pointer mb-4 mr-4" v-if="tableData.length > 0">
                        <div class="p-4 border border-solid d-theme-border-grey-light rounded-full d-theme-dark-bg cursor-pointer flex items-center justify-between font-medium">
                            <span class="mr-2">{{ currentPage * itemsPerPage - (itemsPerPage - 1) }} - {{ tableData.length - currentPage * itemsPerPage > 0 ? currentPage * itemsPerPage : tableData.length }} of {{ tableData.length }}</span>
                            <feather-icon icon="ChevronDownIcon" svgClasses="h-4 w-4" />
                        </div>

                        <vs-dropdown-menu>

                            <vs-dropdown-item @click="itemsPerPage=10">
                                <span>10</span>
                            </vs-dropdown-item>
                            <vs-dropdown-item @click="itemsPerPage=20">
                                <span>20</span>
                            </vs-dropdown-item>
                            <vs-dropdown-item @click="itemsPerPage=50">
                                <span>50</span>
                            </vs-dropdown-item>
                            <vs-dropdown-item @click="itemsPerPage=100">
                                <span>100</span>
                            </vs-dropdown-item>
                            <vs-dropdown-item @click="itemsPerPage=250">
                                <span>250</span>
                            </vs-dropdown-item>
                            <vs-dropdown-item @click="itemsPerPage=500">
                                <span>500</span>
                            </vs-dropdown-item>
                            <vs-dropdown-item @click="itemsPerPage=1000">
                                <span>1000</span>
                            </vs-dropdown-item>
                        </vs-dropdown-menu>
                    </vs-dropdown>
                </div>

                <template slot="thead">
                    <vs-th sort-key="name">Name</vs-th>
                    <vs-th sort-key="template">Template</vs-th>
                </template>

                <template slot-scope="{data}">
                    <tbody>
                        <vs-tr :data="tr" :key="index" v-for="(tr, index) in data">

                            <vs-td :data="data[index].name">
                                {{ data[index].name }}
                            </vs-td>

                            <vs-td :data="data[index].template">
                                {{ data[index].template }}
                            </vs-td>

                        </vs-tr>
                    </tbody>
                </template>

            </vs-table>
        </vx-card>

    </div>
</template>
<script>

    export default {
        props: {
            templateList: {
                type: Number,
                required: true
            }
        },
        data() {
            return {

                itemsPerPage: 100,
                isMounted: false,

                templates: [],
                addTemplateCard: false,

                addObject: {},
                paramNames: {},
                paramDefaults: {},
                integratedParams: [
                    'channel_name',
                    'channel_name_serialized',
                    'channel_id',
                    'worker_channel_name',
                    'worker_channel_name_serialized',
                    'worker_channel_id',
                    'local_http_folder',
                    'local_http_m3u8',
                    'worker_name',
                    'worker_id',
                    'remote_http_folder',
                    'remote_http_m3u8',
                    'source_url',
                    'remote_worker_ip',
                    'drm_signer',
                    'drm_key_server',
                    'drm_content_id',
                    'drm_signing_key',
                    'drm_signing_iv'
                ]

            }
        },
        watch: {
            templateList() {
                this.loadData()
            }
        },
        methods: {
            loadData() {
                this.$vs.loading({
                    container: '#table',
                    type: 'corners',
                    scale: 0.7
                })

                const thisIns = this
                const loadPromise = this.$http.get('/api/management/v1/template/?type=' + this.templateList)
                loadPromise.then(function(response) {
                    thisIns.templates = response.data
                    thisIns.$vs.loading.close('#table > .con-vs-loading')
                })

                loadPromise.catch(function(error) {
                    thisIns.$printError(error.response.data)
                    thisIns.$vs.loading.close('#table > .con-vs-loading')
                })
            },
            addTemplate() {
                this.$vs.loading({
                    container: '#addTemplateDiv',
                    type: 'corners',
                    scale: 0.7
                })

                const thisIns = this

                const parameters = []

                for (let i = 0; i < this.templateParams.length; i++) {
                    parameters.push({
                        key: this.templateParams[i],
                        name: this.paramNames[this.templateParams[i]],
                        default: this.paramDefaults[this.templateParams[i]]
                    })
                }

                const addPromise = this.$http.post('/api/management/v1/template/', {
                    name: this.addObject.name,
                    template: this.addObject.template,
                    type: Number(this.templateList),
                    params: parameters
                })

                addPromise.then(function(response) {
                    thisIns.$printSuccess('Template added')
                    thisIns.$vs.loading.close('#addTemplateDiv > .con-vs-loading')
                    thisIns.$nextTick(() => {
                        thisIns.$router.push('/template/' + response.data.id)
                    })
                })

                addPromise.catch(function(error) {
                    thisIns.$printError(error.response.data)
                    thisIns.$vs.loading.close('#addTemplateDiv > .con-vs-loading')
                })
            },
            openTemplate(tr) {
                this.$router.push('/template/' + tr.id)
            }
        },
        computed: {
            currentPage() {
                if (this.isMounted) {
                    return this.$refs.table.currentx
                }
                return 0
            },
            tableData() {
                return this.templates
            },
            templateParams() {
                const regex = /{{\.(.*?)}}/g
                const matches = []
                let match = regex.exec(this.addObject.template)
                while (match != null) {
                    if (!this.integratedParams.includes(match[1])) {
                        matches.push(match[1])
                    }
                    match = regex.exec(this.addObject.template)
                }

                return matches
            },
            templateInputValid() {
                if (!this.addObject.template || this.addObject.template.length === 0) return false
                if (!this.addObject.name || this.addObject.name.length === 0) return false

                for (let i = 0; i < this.templateParams.length; i++) {
                    if (!this.paramNames.hasOwnProperty(this.templateParams[i]) || this.paramNames[this.templateParams[i]].length === 0) return false
                    if (!this.paramDefaults.hasOwnProperty(this.templateParams[i]) || this.paramDefaults[this.templateParams[i]].length === 0) return false
                }

                return true
            }
        },
        mounted() {
            this.isMounted = true
            this.loadData()
        }

    }

</script>
